var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.599 236.799C297.599 192.799 253.599 148.799 209.599 104.799C203.199 98.3987 196.799 91.9987 190.399 85.5987C175.999 71.1987 152.799 93.5987 167.999 107.999C211.999 151.999 255.999 195.999 299.999 239.999C302.399 242.399 304.799 244.799 307.199 247.199C267.199 287.199 227.199 327.199 187.199 367.199C180.799 373.599 175.199 379.199 168.799 385.599C154.399 399.999 176.799 423.199 191.199 407.999L322.399 276.799L340.799 258.399C347.999 253.599 347.999 243.199 341.599 236.799Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic_arrow_right.ee0711257ff3f4e0102260de2d34b03a.svg";
export { ForwardRef as ReactComponent };